export default function pluralise (text, number, suffix = 's') {
    return text + (number === 1 ? '' : suffix);
}

export function pluraliseReversed (text, number, suffix = 's') {
    return text + (number > 1 ? '' : suffix);
}
